import { BankContext, BankProvider } from './context'
import { BalanceAsOf, BankBalance, UsersBalance } from './ui'

export const Bank = {
    BankBalance: BankBalance,
    UsersBalance: UsersBalance,
    BalanceAsOf: BalanceAsOf,
    Provider: BankProvider,
    Context: BankContext,
}
